import camelcaseKeys from 'camelcase-keys';
import snakecaseKeys from 'snakecase-keys';

import type { IdentifierAssociationsReportRequest, IdentifierAssociationsResponse, PagedIdentifierAssociationsRequest } from '@cobliteam/api-lib';

import type { Configuration } from '../..';
import HttpMethod from '../../request/HttpMethod';
import Requester from '../../request/Requester';
import TimeZone from '../../request/Timezone';

export class IdentifierAssociationsRequester {
  private requester: Requester;

  private baseUrl: string;

  constructor(configuration: Configuration) {
    this.requester = new Requester(configuration);
    this.baseUrl = '/analytics/v1';
  }

  public getIdentifierAssociations = async (request: PagedIdentifierAssociationsRequest): Promise<IdentifierAssociationsResponse> => {
    const requestData = {
      endpoint: `${this.baseUrl}/identifier-associations`,
      method: HttpMethod.POST,
      body: JSON.stringify(
        snakecaseKeys({
          ...request,
          timezone: TimeZone.getTimezone(),
        })
      ),
    };

    const response = await this.requester.request(requestData);
    return camelcaseKeys(response.data.data, { deep: true });
  };

  public requestIdentifierAssociationsReport = async (request: IdentifierAssociationsReportRequest): Promise<string> => {
    const requestBody = {
      ...snakecaseKeys(request),
      timezone: TimeZone.getTimezone(),
    };

    const requestData = {
      endpoint: `${this.baseUrl}/identifier-associations/report/mail`,
      method: HttpMethod.POST,
      body: JSON.stringify(requestBody),
    };

    const response = await this.requester.request(requestData);
    return response.data.data;
  };
}

export default IdentifierAssociationsRequester;
